import styled from 'styled-components';
import { vars } from '../../../../theme';
import spacing from '../../../../styles/spacing';
import { HBSideNavWidget } from '../HBSideNavWidget';
import { DrawerState } from '../../../HBSideDrawer/useSideDrawerState';

export const StyledWidget = styled(HBSideNavWidget)`
    flex-direction: row;
    align-items: center;
    gap: ${spacing[8]};
`;

export const WidgetPrefixWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

export const ContentAndActionContainer = styled.div<{
    $drawerState: DrawerState;
    $hasWidgetPrefix: boolean;
}>`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: ${spacing[4]};
    flex: 1;
    min-width: 0;
    overflow: hidden;
    max-height: ${({ $drawerState }) => {
        switch ($drawerState) {
            case 'expanding':
            case 'expanded':
                return '100px';
            case 'collapsed':
                return '0';
        }
    }};
    opacity: ${({ $drawerState }) => {
        switch ($drawerState) {
            case 'expanding':
            case 'expanded':
                return '1';
            case 'collapsed':
            case 'collapsing':
                return '0';
        }
    }};
    transition: max-height 100ms ease-in-out, opacity 100ms ease-in-out;
`;

export const PrefixAndContentContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacing[8]};
    flex: 1 0 0;
    min-width: 0;
`;

export const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spacing[4]};
    flex: 1 0 0;
    min-width: 176px;
    max-height: 54px;
    overflow: hidden;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacing[6]};
    white-space: nowrap;
    overflow: hidden;
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 0;

    i {
        line-height: 0;
    }

    svg {
        width: 16px;
        height: 16px;
        fill: ${vars.colors.text.invertedPrimary};
    }
`;
